export const firebaseConfig = {
    apiKey: "AIzaSyCFuwN0pVnx6eCb4MaeQ9LqOlQ6CAsTP6g",
    authDomain: "autonomous-vehicle-119b2.firebaseapp.com",
    projectId: "autonomous-vehicle-119b2",
    storageBucket: "autonomous-vehicle-119b2.appspot.com",
    messagingSenderId: "183789131083",
    appId: "1:183789131083:web:ad8470393bde3f3d0004ce",
    measurementId: "G-76LLV9D6S5"
}